/**
 * MobileAuthBouncePage — 모바일 SNS 로그인용 https 중계 페이지
 * 진입: {origin}/auth/mobile-callback/:provider?code=...&state=...
 *
 * Kakao/Naver/Google 모두 리다이렉트 URI로 커스텀 스킴(indipia://)을 직접 등록하지
 * 못하거나(Kakao 콘솔 포맷 거부) 정책상 거부한다(Google Web 클라이언트). 그래서 provider에는
 * 이 https 경로를 등록하고, 이 페이지가 받은 code·state를 그대로 커스텀 스킴에 실어
 * 앱으로 즉시 재전달한다. code·state 검증·교환은 하지 않는다 — 앱이 받아서 gatepass에 직접
 * POST한다(C-05 §11.2 흐름 B, state는 gatepass가 검증).
 */
import { useEffect } from 'react';
import { useParams } from 'react-router';

export function MobileAuthBouncePage() {
  const { provider } = useParams<{ provider: string }>();
  const appUrl = `indipia://auth/callback/${provider}${window.location.search}`;

  useEffect(() => {
    window.location.href = appUrl;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-surface px-6 text-center">
      <p className="text-body-sm text-text-secondary">앱으로 돌아가는 중…</p>
      <a href={appUrl} className="text-body-sm underline">
        자동으로 돌아가지 않으면 여기를 눌러주세요
      </a>
    </div>
  );
}
